module.exports = __webpack_public_path__ + "static/media/fi-back.89e3393d.svg";